'use client';

import type { MouseEvent } from 'react';

import { MenuBulletHorizontal } from '@zoomit/icons';
import { Sheet } from '@zoomit/mobile-sheet';
import { IconButton } from '@zoomit/primitives';
import type { ArticleCardResponse} from '@zoomit/web-kit';
import { ExternalIcon, MoreArticleOptions } from '@zoomit/web-kit';
import { cssVar, theme, Typography } from '@zoomit/zoomit-ds';

import { useOrigin } from '../../providers/OriginProvider';
import RelativeTime from '../shared/RelativeTime';

type Props = { handleEvent?: (clickPosition: string) => void } & ArticleCardResponse;

const BrowseArticleListItemMobileActionSection = (props: Props) => {
  const { id, title, type, isAdvertisement, publishedDate } = props;
  const { baseUrl, isSameOrigin } = useOrigin();

  const { MobileMoreArticleOptions, toggleMoreOptions, isMoreOptionsOpen } = MoreArticleOptions({
    articleId: id,
    title: title,
    url: type === 'External' ? props.link : `${baseUrl}/${props.slug}/`,
    hasBookmark: isSameOrigin,
  });
  const handleMoreOptionsClick = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    await toggleMoreOptions();
  };

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {isAdvertisement && (
          <>
            <Typography
              className="color-exception-ad-title"
              variant="subhead"
              textColor={cssVar(theme.primary1)}
            >
              تبلیغات
            </Typography>
            <div className="bg-grey3 h-3.5 w-px" />
          </>
        )}
        {type === 'External' && (
          <>
            <ExternalIcon hegith={12} sponsorLogo={props.sponsorLogo} sponsorName={props.sponsorName} />
            <div className="bg-grey3 h-3.5 w-px" />
          </>
        )}
        {type === 'Internal' && (
          <>
            <Typography
              className="fa color-exception-discuss-count"
              variant="subhead"
              textColor={cssVar(theme.grey1)}
            >
              {props.totalDiscussCount} دیدگاه
            </Typography>
            <div className="bg-grey3 h-3.5 w-px" />
          </>
        )}
        <Typography
          className="fa color-exception-publish-date"
          variant="subhead"
          textColor={cssVar(theme.grey1)}
        >
          <RelativeTime time={publishedDate} timeAgoBasis="one-month" />
        </Typography>
      </div>
      <IconButton
        className="flex h-11 w-11 items-center justify-end"
        touchTargetInset={2}
        onClick={handleMoreOptionsClick}
      >
        <MenuBulletHorizontal fill={cssVar(theme.grey3)} size="md" />
      </IconButton>
      <Sheet isOpen={isMoreOptionsOpen} onClose={toggleMoreOptions}>
        <Sheet.Container>
          <Sheet.CloseIndicator />
          <MobileMoreArticleOptions />
        </Sheet.Container>
        <Sheet.Backdrop />
      </Sheet>
    </div>
  );
};

export default BrowseArticleListItemMobileActionSection;
